export default __webpack_public_path__ + "static/media/tidy_avatar_5.56cf2f54.png";